import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './locales/en/translation.json'
import de from './locales/de/translation.json'
import es from './locales/es/translation.json'
import pt from './locales/pt/translation.json'
import fr from './locales/fr/translation.json'
import zh from './locales/zh/translation.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      es: { translation: es },
      pt: { translation: pt },
      fr: { translation: fr },
      zh: { translation: zh },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'es', 'pt', 'fr', 'zh'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  })

export default i18n
